module.exports = __webpack_public_path__ + "b2a28f3eaac0f1fb983fbc13c896f6c8.svg";